<template>
  <div class="pa-10" >

    <title-page icon="mdi-format-list-numbered">
      {{ $tc('meter-device.external-operator.statement-full', 2) }}
    </title-page>

    <v-breadcrumbs
        :items="[
            {text: $t('reports.reports'), to: {name: 'reports'}, exact: true},
            {text: $tc('meter-device.external-operator.statement-full', 2) },
        ]"
        divider=">"
    ></v-breadcrumbs>


    <v-row class="mt-6">
      <v-col>
        <v-tabs v-model="tabIndex">
          <v-tab>{{ $tc('meter-device.reading.meter') }}</v-tab>
          <v-tab>{{ $tc('meter-device.external-operator.statement-full', 2) }}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-tabs-items v-model="tabIndex">
          <v-tab-item>
            <report-meter-device-statements-reading />
          </v-tab-item>
          <v-tab-item>
            <report-meter-device-statements-external-operator />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import ReportMeterDeviceStatementsReading from "@pages/Report/ReportMeterDeviceStatements/ReportMeterDeviceStatementsReading.vue";
import ReportMeterDeviceStatementsExternalOperator from "@pages/Report/ReportMeterDeviceStatements/ReportMeterDeviceStatementsExternalOperator.vue";

export default {
  components: {
    ReportMeterDeviceStatementsReading,
    ReportMeterDeviceStatementsExternalOperator,
  },
  data() {
    return {
      tabIndex: 0,
    }
  },

  computed: {



  },

  watch: {

  },

  mounted() {

  },

  methods: {

  }
}
</script>

<style lang="scss">

</style>